/**
 * @desc 获取物料分类树形结构
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.MaterialDirectoryTreeDTO>>> {
  return defHttp.get({
    url: '/web/materialManage/listMaterialCategoryTree',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.MaterialDirectoryTreeDTO>>> {
  return defHttp.get({
    url: '/mock/web/materialManage/listMaterialCategoryTree',
  });
}
